import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import styles from "assets/jss/material-dashboard-pro-react/components/inputStyle.js";

const useStyles = makeStyles(styles);

export default function CustomInput(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    success,
    helperText,
    rtlActive,
    passwordToggle,
    initialVisibility,
    width,
  } = props;

  const [visible, setVisible] = useState(initialVisibility || false);

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error,
    [classes.labelRTL]: rtlActive,
  });
  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
    [classes.whiteUnderline]: white,
  });
  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });
  
  let formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  const formControlStyle = width
  ? { width: typeof width === "number" ? `${width}px` : width }
  : undefined;
  
  const helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });

  const finalInputProps = {
    ...inputProps,
    type: passwordToggle ? (visible ? "text" : "password") : inputProps?.type,
    endAdornment: passwordToggle ? (
      <InputAdornment position="end">
        <IconButton onClick={() => setVisible(!visible)}>
          <Icon>{visible ? "visibility_off" : "visibility"}</Icon>
        </IconButton>
      </InputAdornment>
    ) : inputProps?.endAdornment,
  };

  return (
    <FormControl
      {...formControlProps}
      className={formControlClasses}
      style={{
        ...(formControlProps?.style || {}),
        ...formControlStyle,
      }}
    >
      {labelText && (
        <InputLabel
          className={classes.labelRoot + " " + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      )}

      <Input
        classes={{
          input: inputClasses,
          root: classNames(classes.inputRoot),
          disabled: classes.disabled,
          underline: classes.underline,
        }}
        id={id}
        {...finalInputProps}
      />

      {helperText && (
        <FormHelperText id={id + "-text"} className={helpTextClasses}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helperText: PropTypes.node,
  rtlActive: PropTypes.bool,
  passwordToggle: PropTypes.bool,
  initialVisibility: PropTypes.bool,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};